import { createFileRoute } from '@tanstack/react-router'

import { ChangelogsPage } from '#/modules/content/changelogs-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/changelogs')({
  component: ChangelogsPage,
  validateSearch: validateListSearch,
})
